/**
 * Coord brand constants — the single source for the brand peach.
 *
 * Shared between the Tailwind config (CommonJS `require`) and runtime JS that
 * can't use Tailwind classes (inline styles, third-party component props like
 * BeatLoader). On the next retheme, change the values HERE; the hand-tuned
 * primary shade scale in tailwind.config.js must then be re-derived around
 * the new base.
 */
const PRIMARY = '#D97757'; // peach — primary.DEFAULT / primary.500
const PRIMARY_RGB = '217, 119, 87'; // same color, for rgba() shadow/glow values

module.exports = { PRIMARY, PRIMARY_RGB };
